/**
 * Orden por columna de las tablas, en el navegador. Funciones PURAS (sin React) para poder probarlas con un smoke.
 *
 * Reglas, las mismas en todas las tablas de la aplicación:
 *  - Tres estados por columna: sin orden → ascendente → descendente → sin orden (el orden de siempre de la tabla).
 *  - Textos con las reglas del idioma y números dentro del texto como números («Factura 2» antes que «Factura 10»), sin
 *    distinguir mayúsculas ni tildes.
 *  - ☠️ Lo VACÍO (null, undefined, texto en blanco, NaN, fecha inválida) va SIEMPRE al final, en ascendente y en descendente:
 *    una columna con huecos no puede empezar por una pantalla de «—» al invertir el orden.
 *  - Estable: lo que empata conserva el orden de siempre (el de entrada).
 */
const collators = new Map();
function collatorFor(locale) {
    let c = collators.get(locale);
    if (!c) {
        c = new Intl.Collator(locale, { numeric: true, sensitivity: 'base' });
        collators.set(locale, c);
    }
    return c;
}
/** ¿Es un valor «vacío» (va al final)? */
export function isEmptySortValue(v) {
    if (v === null || v === undefined)
        return true;
    if (typeof v === 'string')
        return v.trim() === '';
    if (typeof v === 'number')
        return Number.isNaN(v);
    if (v instanceof Date)
        return Number.isNaN(v.getTime());
    return false;
}
/** Compara dos valores NO vacíos. Distintos tipos se comparan como texto. */
export function compareSortValues(a, b, locale = 'es') {
    if (typeof a === 'number' && typeof b === 'number')
        return a - b;
    if (a instanceof Date && b instanceof Date)
        return a.getTime() - b.getTime();
    if (typeof a === 'boolean' && typeof b === 'boolean')
        return Number(a) - Number(b);
    const sa = a instanceof Date ? a.toISOString() : String(a);
    const sb = b instanceof Date ? b.toISOString() : String(b);
    return collatorFor(locale).compare(sa, sb);
}
/**
 * Ordena una copia de `items` por la columna `key`. Si `key` es null/vacía o no tiene accessor, devuelve la copia SIN ordenar
 * (el orden de siempre).
 */
export function sortRows(items, accessors, key, dir, locale = 'es') {
    const get = key ? accessors[key] : undefined;
    if (!get)
        return [...items];
    const sign = dir === 'desc' ? -1 : 1;
    return items
        .map((item, index) => ({ item, index, value: get(item) }))
        .sort((x, y) => {
        const xe = isEmptySortValue(x.value);
        const ye = isEmptySortValue(y.value);
        if (xe || ye) {
            if (xe && ye)
                return x.index - y.index;
            return xe ? 1 : -1; // lo vacío, siempre al final (sin invertirse con `dir`)
        }
        const c = compareSortValues(x.value, y.value, locale);
        return c !== 0 ? sign * c : x.index - y.index;
    })
        .map((r) => r.item);
}
/** El ciclo de tres estados al pulsar una cabecera. */
export function nextSortState(current, key) {
    if (current.key !== key)
        return { key, dir: 'asc' };
    if (current.dir === 'asc')
        return { key, dir: 'desc' };
    return { key: null, dir: 'asc' };
}
//# sourceMappingURL=table-sort.js.map